import { SchoolDetailBlogValidateType } from '../../type/Blog/SchoolDetailBlogValidate.type';

export const schoolDetailBlogValidateInitial: SchoolDetailBlogValidateType = {
    title: false,
    text: false,
}